/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { postToBackend } from './fetch-util.js';


function setInSession( name_or_map, value ) {
	if( arguments.length===1 && typeof name_or_map==='object' ) {
		for( var k in name_or_map ) {
			if( name_or_map.hasOwnProperty(k) ) mj.session[k] = name_or_map[k];
		}
		if( mj.session_is_valid ) {
			postToBackend('json/session/-set',{'values':name_or_map},function(r) {});
		}
	} else {
		mj.session[name_or_map] = value;
		if( mj.session_is_valid ) {
			postToBackend('json/session/-set','name='+encodeURIComponent(name_or_map)+'&value='+encodeURIComponent(value),function(r) {});
		}
	}
}

function getFromSession( name, default_value ) {
	return mj.session && mj.session.hasOwnProperty(name) ? mj.session[name] : default_value;
}


// function setInSessionIfChanged( name_or_map, value ) {
// 	if( arguments.length===1 && typeof name_or_map==='object' ) {
// 		for( var k in name_or_map ) {
// 			if( name_or_map.hasOwnProperty(k) ) {
// 				const curValue = mj.session[name_or_map] ?? null;
// 				if( name_or_map[k]!==curValue ) {
// 					setInSession(name_or_map);
// 					return true;
// 				}
// 			}
// 		}
// 	} else {
// 		const curValue = mj.session[name_or_map] ?? null;
// 		if( value!==curValue ) {
// 			setInSession(name_or_map,value);
// 			return true;
// 		}
// 	}
// 	return false;
// }



function getFromObjectInSession( name, key, defaultMemberVal ) {
	let curObjStr = mj.session && mj.session.hasOwnProperty(name) ? mj.session[name] : '{}';
	if( curObjStr==='' ) return defaultMemberVal;
	try {
		const curObj = JSON.parse(curObjStr);
		return curObj && curObj.hasOwnProperty(key) ? curObj[key] : defaultMemberVal;
	// eslint-disable-next-line no-empty
	} catch( err ) {
	}
	return defaultMemberVal;
}

function setOnObjectInSession( name, key, newMemberVal, compact ) {
	let curObjStr = mj.session && mj.session.hasOwnProperty(name) ? mj.session[name] : '{}';
	if( curObjStr==='' ) curObjStr = mj.session[name] = '{}';
	try {
		let curObj = JSON.parse(curObjStr);
		const curMemberValStr = curObj[key] ?? '';
		const newMemberValStr = typeof newMemberVal==='object' ? JSON.stringify(newMemberVal) : newMemberVal;
		if( newMemberValStr===curMemberValStr ) return false;

		// update in mj.session ..
		if( newMemberValStr==='' && compact ) delete curObj[key];
		else curObj[key] = newMemberValStr;
		mj.session[name] = JSON.stringify(curObj);

		if( mj.session_is_valid ) {
			// update on server ..
			const postdata = 'name='+encodeURIComponent(name)+'&key='+encodeURIComponent(key)+'&value='+encodeURIComponent(newMemberValStr)+(compact?'&compact=1':'');
			postToBackend('json/session/-set_on_obj',postdata, function( respData ) {
				if( respData && respData.name && respData.hasOwnProperty('value') ) {
					// update in mj.session ..
					mj.session[respData.name] = respData.value;
				}
			} );
		}
		return true;
	// eslint-disable-next-line no-empty
	} catch( err ) {
	}
	return false;
}


export {
	setInSession,
	getFromSession,
	// setInSessionIfChanged,
	getFromObjectInSession,
	setOnObjectInSession,
};
